import { Anchor, Code, Group, Tooltip } from '@mantine/core'
import { IconExternalLink } from '@tabler/icons-react'

import {
  type BlockchainNetwork,
  chain_configs,
} from '@repo/common/blockchain/redeem_config'

import classes from './BlockchainAddress.module.css'

interface BlockchainAddressProps {
  address: string
  network?: BlockchainNetwork | null
}

function truncateAddress(address: string): string {
  if (address.length <= 12) return address
  return `${address.slice(0, 6)}...${address.slice(-4)}`
}

function getExplorerUrl(
  address: string,
  network?: BlockchainNetwork | null,
): string | null {
  if (!network) return null
  const config = chain_configs[network]
  const url = config.scan_url_maker(address)
  return url || null
}

function isFireblocksVaultId(address: string): boolean {
  return /^\d{1,4}$/.test(address)
}

export function BlockchainAddress({
  address,
  network,
}: BlockchainAddressProps) {
  if (isFireblocksVaultId(address)) {
    return (
      <Code style={{ fontSize: '0.75rem' }}>Fireblocks Vault {address}</Code>
    )
  }

  const explorerUrl = getExplorerUrl(address, network)
  const truncated = truncateAddress(address)

  if (explorerUrl) {
    return (
      <Tooltip label={address} multiline maw={400}>
        <Group gap={4} wrap="nowrap" className={classes.root}>
          <Anchor
            href={explorerUrl}
            target="_blank"
            rel="noopener noreferrer"
            size="sm"
            ff="monospace"
          >
            {truncated}
          </Anchor>
          <IconExternalLink size={12} />
        </Group>
      </Tooltip>
    )
  }

  return (
    <Tooltip label={address} multiline maw={400}>
      <Code style={{ fontSize: '0.75rem' }}>{truncated}</Code>
    </Tooltip>
  )
}
